import { render, staticRenderFns } from "./VendasPorPeriodo.vue?vue&type=template&id=a0a0cb5e"
import script from "./VendasPorPeriodo.vue?vue&type=script&lang=js"
export * from "./VendasPorPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports